const masks = require('./masks.json')

const getProvider = (username) => {
  const mask = username.substring(username.lastIndexOf('@') + 1)
  for (const provider in masks) {
    if (masks[provider].includes(mask)) { return provider.toLowerCase() }
  }
}

export { getProvider }



// WEBPACK FOOTER //
// ./src/helpers/sso.js